import React, { useState } from 'react';
import {
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Checkbox, Paper, IconButton, Chip
} from '@mui/material';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { Edit, Delete, ArrowDropDown } from '@mui/icons-material';
import { styled } from '@mui/material/styles';
import moment from 'moment/moment';
import { useDispatch, useSelector } from 'react-redux';
import DeleteModal from '../reusable/deleteModal/DeleteModal';
import CatPagination from '../reusable/catPagination/CatPagination';
import Operations from '../reusable/Operations';
import { useNavigate } from 'react-router-dom';
import { deleteLevel3Thunk, deletemultiplelevel3CategoriesThunk, setLevel3category, setSelectAlllvel3Cat, setSelectedlevel3ids } from '../../redux/level3/getAllLevel3slice';
import { MultipleDeletes } from '../../Svg';
// Styled components using MUI's `styled` API
const TableContainerStyled = styled(TableContainer)(({ theme }) => ({
  borderRadius: 8,
  boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
  border: '1px solid #E0E2E7',
}));

const HeaderCell = styled(TableCell)(({ theme }) => ({
  fontWeight: 'bold',
  backgroundColor: '#f8f9fa',
  color: '#495057',
  padding: '6px 0px 0px 20px',
  fontFamily: `'Public Sans', sans-serif !important`,

}));

const TableCells = styled(TableCell)(({ theme }) => ({
  paddingLeft: '20px',
  fontFamily: `'Public Sans', sans-serif !important`,
}));

const ActionIcons = styled(TableCell)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'flex-start',
  paddingLeft: '6px',
  borderBottom: '1px solid rgba(224, 224, 224, 1)',
}));

const ProductText = styled(TableCell)(({ theme }) => ({
  color: '#495057',
  fontWeight: 'bold',
  paddingLeft: '20px',
  fontFamily: `'Public Sans', sans-serif !important`,
}));

const InactiveChip = styled(Chip)(({ theme }) => ({
  backgroundColor: '#ffc9c9',
  color: '#d9534f',
  fontWeight: 'bold',
  borderRadius: '4px',
  lineHeight: '24px',
  fontSize: '14px',
  fontFamily: `'Public Sans', sans-serif !important`,
}));

const ActiveChip = styled(Chip)(({ theme }) => ({
  backgroundColor: '#d4edda',
  color: '#28a745',
  fontWeight: 'bold',
  borderRadius: '4px',
  lineHeight: '24px',
  fontSize: '14px',
  fontFamily: `'Public Sans', sans-serif !important`,
}));




const LevelTable = ({ level3, start, end, setPage, page, totalItems, itemsPerPage, handleOpenMenu }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [activeColumn, setActiveColumn] = useState(null);
  const [selectedId, setSelectedId] = useState(null)
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { selectedIds, selectAll } = useSelector((state) => state.level3);

  const dispatch = useDispatch()
  const navigate = useNavigate()


  const deleteCategory = () => {
    dispatch(deleteLevel3Thunk(selectedId))
    setIsModalOpen(false);

  }



  const handleDeleteClick = (id) => {
    setIsModalOpen(true);
    setSelectedId(id)
  };

  const handleEditClick = (level3data) => {
    dispatch(setLevel3category(level3data));
    navigate('/master/editLevel')
  };



  const handleSelect = (id) => {
    const isExist = selectedIds.includes(id)
    if (isExist) {
      const filter = selectedIds?.filter(i => i !== id)
      return dispatch(setSelectedlevel3ids(filter))
    }
    const data = [...selectedIds, id]
    dispatch(setSelectedlevel3ids(data))
  }


  const handleSelectAll = () => {
    if (!selectAll) {
      const ids = level3?.map(i => i?._id)
      dispatch(setSelectedlevel3ids(ids))
      return dispatch(setSelectAlllvel3Cat(true))
    }
    dispatch(setSelectedlevel3ids([]))
    dispatch(setSelectAlllvel3Cat(false))
  }

  const handleMultipledelete = () => {
    const data = {
      ids: selectedIds
    }
    dispatch(deletemultiplelevel3CategoriesThunk(data))
  }



  return (
    <>
      <TableContainerStyled component={Paper}>
        <Table>
          <TableHead>
            <TableRow>

              {/* <HeaderCell padding="checkbox" sx={{ width: '2%' }}>
                <Checkbox color="primary" />
              </HeaderCell> */}

              <HeaderCell>
                <IconButton>
                  <input
                    type="checkbox"
                    checked={selectAll}
                    onChange={handleSelectAll}
                  />
                </IconButton>
                Subcategory level 3
                <IconButton onClick={(e) => handleOpenMenu('name')}>
                  <ArrowDropDown />
                </IconButton>
              </HeaderCell>

              <HeaderCell >
                Category
                <IconButton onClick={(e) => handleOpenMenu('category')}>
                  <ArrowDropDown />
                </IconButton>
              </HeaderCell>

              <HeaderCell>
                Subcategory
                <IconButton onClick={(e) => handleOpenMenu('subcategory')}>
                  <ArrowDropDown />
                </IconButton>
              </HeaderCell>

              <HeaderCell>
                Status
                <IconButton onClick={(e) => handleOpenMenu('thumbnail.status')}>
                  <ArrowDropDown />
                </IconButton>
              </HeaderCell>

              <HeaderCell>
                Added
                <IconButton onClick={(e) => handleOpenMenu('createdAt')}>
                  <ArrowDropDown />
                </IconButton>
              </HeaderCell>

              <HeaderCell>
                Action
                {selectedIds?.length > 0 &&
                  <IconButton onClick={handleMultipledelete}>
                    <MultipleDeletes />
                  </IconButton>
                }
              </HeaderCell>
            </TableRow>

          </TableHead>

          <TableBody >
            {level3?.map((row) => (
              <TableRow key={row.id}>
                {/* <TableCell padding="checkbox" sx={{ width: '2%' }}>
                  <Checkbox color="primary" sx={{ borderRadius: '12px' }} />
                </TableCell> */}

                <TableCells sx={{
                  width: '25%',

                }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    {/* <div>
                      {
                        row?.thumbnail?.photo ? <img src={row?.thumbnail?.photo} style={{ width: 44, height: 44, borderRadius: 2 }} /> : <img src="/assets/profile.png" />
                      }
                    </div> */}
                    <div>
                      <input
                        type="checkbox"
                        checked={selectedIds.find(i => i == row?._id)}
                        onChange={() => handleSelect(row?._id)}
                      />
                    </div>
                    <div style={{
                      maxWidth: "80%",
                      whiteSpace: 'normal',
                      wordWrap: 'break-word'
                    }}>
                      <strong style={{ color: '#1D1F2C' }} >
                        {row.name}
                      </strong>
                      <div style={{ fontSize: '14px', color: '#667085', fontWeight: '500', maxWidth: 120, overflow: 'hidden', textOverflow: 'ellipsis' }} >
                        {row.description}
                      </div>
                    </div>
                  </div>
                </TableCells>

                <ProductText sx={{ width: '25%', color: "#667085", }}>
                  <div style={{   maxWidth: "80%",
                       whiteSpace: 'normal',
                      wordWrap: 'break-word' }} >

                    {row.category?.name}
                  </div>
                </ProductText>

                <ProductText sx={{ width: '16%', color: "#667085", }}>
                  <div style={{   maxWidth: "80%",
                       whiteSpace: 'normal',
                      wordWrap: 'break-word' }} >
                    {row.subcategory?.name}
                  </div>
                </ProductText>

                <TableCells sx={{ width: '13%' }}>
                  {row?.thumbnail?.status === "ACTIVE" ? (
                    <ActiveChip label="Active" size="small" />
                  ) : (
                    <InactiveChip label="Inactive" size="small" />
                  )}
                </TableCells>

                <TableCells sx={{ width: '13%', fontSize: '14px', color: '#667085', fontWeight: '500' }}>
                  {moment(row.createdAt).format('DD MMM YYYY')}
                </TableCells>

                <Operations
                  TableCells={TableCells}
                  viewClick={() => navigate(`/master/viewLevel/${row?._id}`)}
                  editClick={() => handleEditClick(row)}
                  deleteClick={() => handleDeleteClick(row?._id)}
                />
                <DeleteModal
                  isOpen={isModalOpen}
                  heading={'Level 3 Category'}
                  onClose={() => setIsModalOpen(false)}
                  onDelete={deleteCategory}
                />
              </TableRow>
            ))}
          </TableBody>
        </Table>
        <div>
          <CatPagination
            start={start}
            end={end}
            totalItems={totalItems}
            itemsPerPage={itemsPerPage}
            setPage={setPage}
            page={page}
          />
        </div>
      </TableContainerStyled>

    </>
  );
};

export default LevelTable;
